<template>
  <Modal v-model="purchaseStoreLimitModal" :title="purchaseStoreLimitTitle" :width="560" :transfer="false" :mask-closable="false"
    @on-visible-change="purchaseStoreLimitChange">
    <div class="table_box">
      <Table
        highlight-row
        border
        max-height="550"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <template #footer>
      <Button @click="purchaseStoreLimitModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" :disabled="purchaseStoreLimitTalg" @click="purchaseStoreLimitBtn">{{ purchaseStoreLimiText }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {isAlibabaDistributor} from "@/utils/common";
import {startLoading, endLoading} from "@/utils/loading";

export default {
  name: 'purchaseStoreLimitModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      purchaseStoreLimitModal: false,
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005806'),
          key: 'selectDuration',
          align: 'center',
          width: 100,
          render(h, params) {
            let selectDuration = params.row.selectDuration;
            return h('div', [
              selectDuration ? h('Icon', {
                props: {
                  type: 'md-checkmark',
                  size: 18
                },
                class: 'themeColor'
              }) :
                h('span', {
                  class: 'cursor themeColor',
                  on: {
                    click() {
                      v.changeDuration(params.index);
                    }
                  }
                }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001106'))
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005807'),
          key: 'storeDuration',
          align: 'left',
          minWidth: 150
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005808'),
          key: 'renewalPrice',
          align: 'left',
          minWidth: 150
        },
      ],
      tableData: [
        {selectDuration: false, storeDuration: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005809'), renewalMonth: 1, renewalPrice: 30},
        {selectDuration: false, storeDuration: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005810'), renewalMonth: 3, renewalPrice: 72},
        {selectDuration: false, storeDuration: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005811'), renewalMonth: 6, renewalPrice: 126},
        {selectDuration: false, storeDuration: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005812'), renewalMonth: 12, renewalPrice: 216},
      ],
      purchaseStoreLimitTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005813'),
      purchaseStoreLimiText: '',
      ymsPlatformAccountId: null,
      purchaseStoreLimitType: 'buy',
      webSocketListenerKey: ''
    }
  },
  beforeDestroy() {
    this.clearWebSocketListener();
  },
  computed: {
    purchaseStoreLimitTalg() {
      let talg = this.tableData.some((item) => {
        return item.selectDuration === true;
      });
      return !talg;
    }
  },
  methods: {
    // 初始化数据
    initPurchaseStoreLimitData(ymsPlatformAccountId, type) {
      let obj = {
        buy: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005813'),
        renew: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005814')
      };
      this.purchaseStoreLimiText = type === 'buy' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001712') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005815');
      this.purchaseStoreLimitTitle = obj[type];
      this.purchaseStoreLimitModal = true;
      this.purchaseStoreLimitType = type;
      this.ymsPlatformAccountId = ymsPlatformAccountId;
      this.initWebSocket();
    },
    // 选择时长
    changeDuration(index) {
      this.tableData.map((item, idx) => {
        item.selectDuration = false;
        if (idx === index) {
          this.$set(this.tableData[index], 'selectDuration', true);
        }
      });
      this.$forceUpdate();
    },
    // 开通、续费
    purchaseStoreLimitBtn() {
      let v = this;
      sessionStorage.removeItem('payForm');
      let list = v.tableData.filter((item) => {
        return item.selectDuration === true;
      });
      if (list.length > 0) {
        let query = {
          ymsPlatformAccountId: v.ymsPlatformAccountId,
          renewalPrice: list[0].renewalPrice,
          renewalMonth: list[0].renewalMonth
        };
        v.axios.post(api.post_ymsPlatformAccount_confirmRenewal, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              sessionStorage.setItem('payForm', data);
              setTimeout(() => {
                startLoading(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005816'));
                window.open('./payCallback.html', '_blank');
              }, 500);
            } else {
              v.purchaseStoreLimitModal = false;
              let text = v.purchaseStoreLimitType === 'buy' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005817') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005818');
              v.$Message.success(text);
              v.$emit('updateData', true);
            }
          }
        });
      }
    },
    /**
     * 注册购买店铺额度支付结果使用的 websocket 监听。
     */
    initWebSocket() {
      let v = this;
      if (!v.$webSocket.initWebSocket()) {
        return;
      }
      v.webSocketListenerKey = `purchase-store-limit-${v._uid}`;
      v.$webSocket.subscribeMessage(v.webSocketListenerKey, (e) => {
        const data = v.$webSocket.parseMessage(e);
        if (data && data.type === 'pay' && isAlibabaDistributor()) {
          let text = v.purchaseStoreLimitType === 'buy' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005817') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005818');
          let errorText = v.purchaseStoreLimitType === 'buy' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005819') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005820');
          if (data.data.status === 2) {
            endLoading();
            setTimeout(() => {
              v.$Message.success(text);
              v.$emit('updateData', true);
              v.purchaseStoreLimitModal = false;
            }, 2000);
          } else if (data.data.status === 3) {
            endLoading();
            v.$Message.error(errorText);
            v.purchaseStoreLimitModal = false;
          }
        }
      });
    },

    /**
     * 清理购买店铺额度支付结果监听。
     */
    clearWebSocketListener() {
      if (!this.webSocketListenerKey) return;
      this.$webSocket.unsubscribeMessage(this.webSocketListenerKey);
      this.webSocketListenerKey = '';
    },
    // 监听弹窗
    purchaseStoreLimitChange(value) {
      if (!value) {
        this.tableData.map((item) => {
          item.selectDuration = false;
        });
        this.$forceUpdate();
      }
    }
  }
};
</script>

<style lang="less">

</style>
